import React, { SVGProps, useEffect, useState } from "react";
// import Logo from "../../assests/OC_Main_Logo.png";
import Logo from "../../assests/OC_Logo.svg";
import OcAllInLogo from "../../assests/APP LOGOS_ALL IN.svg";
import PlcLogo from "../../assests/APP LOGOS_PLC.svg";
import DtsLogo from "../../assests/APP LOGOS_DTS.svg";
import HealthWellness from "../../assests/APP LOGOS_HealthWellness.svg";
import "./Sidebar.css";
import { useLocation, useNavigate } from "react-router-dom";
import { reactIcons } from "../../icons/reactIcons";
import {
  dtsSidebarMenuItems,
  plcSidebarMenuItems,
  sidebarMenuItems,
  superAdminSidebaeMenuItems,
  thirtyForThirtyMenuItem,
} from "../../data/data";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { setPlcTermDataValue } from "../../redux/plc/ReportsReducer/ReportsSlice";
import { setTermCodeValue } from "../../redux/RewardReducer/RewardsSlice";

interface sidebarprops {
  // setIsAuthenticated: (isAuthenticated: string) => void;
}

export interface sidebarMenuItemsProps {
  id: number;
  title: string;
  icon: React.FC<SVGProps<SVGSVGElement>>;
  path: string;
}

export interface sidebarMenu {
  id: number;
  parent: string;
  children: sidebarMenuItemsProps[];
}

const Sidebar: React.FC<sidebarprops> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatcher = useDispatch();
  const activePath = location.pathname;
  const { featureName } = useSelector((state: RootState) => state?.AuthCard);
  const { termDataList_details } = useSelector(
    (state: RootState) => state.TermData,
  );
  const { plcTermCodesList } = useSelector(
    (state: RootState) => state.PlcReports,
  );

  const [openId, setOpenId] = useState<number | null>(1);

  const [sidebarData, setSideBarData] = useState<sidebarMenu[]>([]);
  const [path, setPath] = React.useState<string>(
    featureName === "super_admin"
      ? "/super-admin/admins"
      : featureName === "oc_all_in"
        ? "/oc-all-in/term-data"
        : featureName === "plc"
          ? "/plc/events"
          : "",
  );

  const toggleAccordion = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  //using the following state to show the loaderBtn
  const [loaderBtn, setLoaderBtn] = useState(false);

  //using the following useEffect to set the sidebarMenuItems based on the featureName
  useEffect(() => {
    let sidebarData = activePath.startsWith("/oc-all-in")
      ? sidebarMenuItems
      : activePath.startsWith("/super-admin")
        ? superAdminSidebaeMenuItems
        : activePath?.startsWith("/plc")
          ? plcSidebarMenuItems
          : activePath.startsWith("/dts")
            ? dtsSidebarMenuItems
            : activePath.startsWith("/thirty-for-thirty")
              ? thirtyForThirtyMenuItem
              : [];
    setSideBarData(sidebarData);
  }, [activePath]);

  //using the following useEffect to open the active accordian
  useEffect(() => {
    const activeParent = sidebarData.find((parent) =>
      parent.children.some((child) => activePath.startsWith(child.path)),
    );
    if (activeParent) {
      setOpenId(activeParent.id);
    }
  }, [activePath, sidebarData]);

  const handlePath = (path: string) => {
    navigate(path);
    setPath(path);
    handleRefreshTermCodeValue();
  };

  const handleRefreshTermCodeValue = () => {
    if (activePath.startsWith("/oc-all-in")) {
      let currentTerm = termDataList_details?.find((term) => term.currentTerm);
      dispatcher(setTermCodeValue(currentTerm?.id ?? ""));
    } else {
      const selectedTermCode =
        plcTermCodesList?.find((item) => item?.currentTerm)?.id ??
        plcTermCodesList?.[0]?.id ??
        "";
      dispatcher(setPlcTermDataValue(selectedTermCode));
    }
  };

  const getSidebarLogo = () => {
    if (activePath.startsWith("/oc-all-in")) {
      return { src: OcAllInLogo, alt: "OC All-In" };
    }
    if (activePath.startsWith("/plc")) {
      return { src: PlcLogo, alt: "PLC" };
    }
    if (activePath.startsWith("/dts")) {
      return { src: DtsLogo, alt: "DTS" };
    }
    if (activePath.startsWith("/thirty-for-thirty")) {
      return { src: HealthWellness, alt: "30 for 30", className: "tft" };
    }
    if (featureName === "oc_all_in") {
      return { src: OcAllInLogo, alt: "OC All-In" };
    }
    if (featureName === "plc") {
      return { src: PlcLogo, alt: "PLC" };
    }
    if (featureName === "dts") {
      return { src: DtsLogo, alt: "DTS" };
    }
    if (featureName === "tft") {
      return { src: HealthWellness, alt: "30 for 30", className: "tft" };
    }

    return { src: Logo, alt: "Odessa College" };
  };

  const sidebarLogo = getSidebarLogo();

  return (
    <nav className="sidebar" aria-label="Super Admin Sidebar">
      <div className="sidebar-logo-container">
        <img
          src={sidebarLogo.src}
          alt={sidebarLogo.alt}
          className={`oc-main-logo ${
            "className" in sidebarLogo ? sidebarLogo.className : ""
          }`}
        />
      </div>
      <div className="sidebar-menu-scroll">
        {sidebarData.map((parent) => {
          const isOpen = openId === parent.id;
          return (
            <div key={parent.id} className="sidebar-accordion-section">
              {/* Accordion Header */}
              {parent?.parent !== "" && (
                <button
                  className={`${parent?.parent === "" ? "" : "sidebar-accordion-header"}`}
                  onClick={() => toggleAccordion(parent.id)}
                  aria-expanded={isOpen}
                  aria-controls={`section-${parent.id}`}
                  id={`accordion-${parent.id}`}
                >
                  {parent.parent}
                  <span className="accordion-icon">
                    {isOpen ? (
                      <reactIcons.arrowUp className="sidebar-menu-icon" />
                    ) : (
                      <reactIcons.arrowDown className="sidebar-menu-icon" />
                    )}
                  </span>
                </button>
              )}

              {/* Accordion Panel */}
              <div
                id={`section-${parent.id}`}
                role="region"
                aria-labelledby={`accordion-${parent.id}`}
                hidden={!isOpen}
                className="sidebar-accordion-panel"
              >
                {parent.children.map((item) => (
                  <div
                    key={item.id}
                    className="sidebar-menu-container"
                    onClick={() => handlePath(item.path)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) =>
                      (e.key === "Enter" || e.key === " ") &&
                      handlePath(item.path)
                    }
                  >
                    {/* {item?.title} */}
                    <div
                      className={`${
                        // activePath.startsWith(item.path) ? "sidebar-barline" : ""
                        activePath === item.path ? "sidebar-barline" : ""
                      }`}
                    ></div>
                    <div
                      className={`${
                        //
                        //activePath.startsWith(item?.path) ? "active" : "inActive"
                        activePath === item.path ? "active" : "inActive"
                      }`}
                    >
                      <item.icon
                        className={`${item?.title === "Reward Type" ? "sidebar-rewardIcon " : item.title === "Master" ? "master-icon " : ""}${
                          // activePath.startsWith(item.path)
                          //   ? "sidebar-active-icon"
                          //   : "sidebar-inActive-icon"
                          activePath === item.path
                            ? "sidebar-active-icon"
                            : "sidebar-inActive-icon"
                        }`}
                      />
                      <span className="sidebar-title">{item.title}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </nav>
  );
};

export default Sidebar;
